import React, { useEffect } from 'react';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import useLanguageStore from '../../store/languageStore';

const LanguageSelector = ({ eventData }) => {
    const {
        currentLanguage,
        availableLanguages,
        isMultilingual,
        initializeLanguage,
        setLanguage,
    } = useLanguageStore();
    // Get language display name (helper function)
    const getLanguageDisplayName = (langCode) => {
        const languageNames = {
            'it': 'Italiano',
            'en': 'EN',
            'es': 'Español',
            'fr': 'Français',
            'de': 'DE',
            'pt': 'Português',
        };
        return languageNames[langCode] || langCode.toUpperCase();
    };

    // Inizializza la lingua quando cambia eventData
    useEffect(() => {
        if (eventData) {
            initializeLanguage(eventData);
        }
    }, [eventData, initializeLanguage]);

    const handleLanguageChange = (event) => {
        const newLang = event.target.value;
        setLanguage(newLang);
    };

    // Se multilingua è false o c'è solo una lingua, non mostrare il selettore
    if (!isMultilingual || availableLanguages.length <= 1) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 8,
                right: 8,
                zIndex: 1000,
            }}
        >
            <FormControl size="small" sx={{ maxWidth: 140 }}>
                <Select
                    value={currentLanguage}
                    onChange={handleLanguageChange}
                    displayEmpty
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', alignItems: 'center'}}>
                            <Typography variant="body2">
                                {getLanguageDisplayName(selected)}
                            </Typography>
                        </Box>
                    )}
                >
                    {availableLanguages.map((lang) => (
                        <MenuItem key={lang} value={lang}>
                            <Box sx={{ display: 'flex', alignItems: 'center'}}>
                                <Typography variant="body2">
                                    {getLanguageDisplayName(lang)}
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default LanguageSelector;

